export const DESCARTE_RELATORIOS_ATUALIZAR_DATA_INICIO = 'DESCARTE_RELATORIOS_ATUALIZAR_DATA_INICIO';
export const dataInicio = (dataInicio) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_DATA_INICIO,
  payload: {
    dataInicio,
  },
});
export const DESCARTE_RELATORIOS_ATUALIZAR_DATA_FIM = 'DESCARTE_RELATORIOS_ATUALIZAR_DATA_FIM';
export const dataFim = (dataFim) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_DATA_FIM,
  payload: {
    dataFim,
  },
});

export const DESCARTE_RELATORIOS_ATUALIZAR_FILTRO_VALUE = 'DESCARTE_RELATORIOS_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});
export const DESCARTE_RELATORIOS_ATUALIZAR_LISTA = 'DESCARTE_RELATORIOS_ATUALIZAR_LISTA';
export const lista = (lista) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_LISTA,
  payload: {
    lista,
  },
});
export const DESCARTE_RELATORIOS_ATUALIZAR_TIPO = 'DESCARTE_RELATORIOS_ATUALIZAR_TIPO';
export const tipo = (tipo) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_TIPO,
  payload: {
    tipo,
  },
});
export const DESCARTE_RELATORIOS_ATUALIZAR_IMPRIMIR = 'DESCARTE_RELATORIOS_ATUALIZAR_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: DESCARTE_RELATORIOS_ATUALIZAR_IMPRIMIR,
  payload: {
    imprimir,
  },
});




// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/relatorios/store/relatorios.action.js